<section #headerSection class="header-section" *ngIf="!!cardDetails">
  <div class="box" *ngIf="!headerContent?.enableBoxDesign">
      <h1 id="headerSection"  [innerHTML]="cardDetails?.cardName+' '+cardDetails?.cardTagLine | adaFriendlyName: 'ignoreHtmlTags'"></h1>
      <div class="header-wrapper card_{{cardDetails?.pid}}">
          <div class="header-details">
              <div *ngIf="headerContent?.offerActive" class="header-offer-box">
                  <div class="green-tag-best-award" *ngIf="headerContent.offerType === 'image'">
                      <span class="best-award"
                          [ngStyle]="{'background-image': 'url(' + headerContent.offerImagePath + ')'}"
                      ></span>
                      <span class="green-tag-support-text-highlight promo-header"
                          role="heading"
                          aria-level="2"
                          [ngStyle]="{'background-color': headerContent.backgroundColor, 'color': headerContent.textColor}"
                          [innerHTML]="headerContent?.offerTitle | adaFriendlyName: 'ignoreHtmlTags'"
                      ></span>
                  </div>
                  <div class="green-tag-low-intro" *ngIf="headerContent.offerType === 'text'">
                      <span class="green-tag"
                          [ngStyle]="{'background-color': headerContent.backgroundColor, 'color': headerContent.textColor}">
                          <span class="green-tag-text promo-header"
                              role="heading"
                              aria-level="2"
                              [innerHTML]="headerContent?.offerTitle | adaFriendlyName: 'ignoreHtmlTags'"
                          ></span>
                      </span>
                  </div>
              </div>
              <div *ngIf="headerContent.offerSummary" class="offer-summary"
                  [innerHTML]="headerContent?.offerSummary | safeHtml"></div>
              <div class="header-description-box">
                  <div class="promo-wrapper">
                      <div class="promo-icon"><i class="icons"
                              [ngStyle]="{'background-image': 'url(' + headerContent.iconPath + ')'}"></i></div>
                      <div class="promo-container">
                          <div class="promo-copy" [innerHTML]="headerContent?.description | safeHtml"></div>
                          <div class="promo-disclaimer" [innerHTML]="headerContent?.offerDisclaimer | safeHtml"></div>
                      </div>
                  </div>
              </div>

            </div>
            <div class="header-cards">
                <div class="image-rating-button">
                    <div class="left">
                        <app-card-art
                            [pid]="cardDetails?.pidPT"
                            [defaultSize]="cardImageSize"
                            [linkHref]="cardApplyNowBtnLink"
                            [linkTarget]="'_blank'"
                            [enablePdpLink]="false"
                        ></app-card-art>
                        <div class="spacer-10" role="presentation" aria-hidden="true"></div>
                        <ui-card-rating [pid]="cardDetails?.pid" (handleReviewClick)="scrollToReviewSection('reviewSection')"
                            [title]="cardDetails?.cardName" *ngIf="reviewContent?.reviewActive" [hideDetailReview]="false" [disableReviewModal]="true" [scrollToSection]="true">
                        </ui-card-rating>
                        <div class="spacer-10" role="presentation" aria-hidden="true"></div>
                        <button cdsButton="inlineLink card-button" [innerHTML]="cardDetails?.cardPricingDetailText" [ngClass]="{'hidden': !isMobileWithoutRating()}"
                        (click)="[scroll('#pricingDetailsSection'), anchorLink(cardDetails?.cardPricingDetailText)]" id="Pricing"></button>
                    </div>
                    <div class="right">
                        <ui-card-button [btnName]="cardDetails?.cardApplyNowBtnText" [tagText]="cardDetails?.cardApplyNowBtnText.toLowerCase()+' top'"
                            [btnLink]="cardApplyNowBtnLink" [cardName]="cardDetails?.cardName" [hrefTarget]="hrefTarget" (click)="applyNow('Hero')">
                        </ui-card-button>
                        <div class="customer-support" [innerHTML]="cardDetails?.customerSupportText"></div>
                        <div class="card-button desk" [ngClass]="{'hidden': isMobileWithoutRating()}">
                            <button role="link" cdsButton="inlineLink" [innerHTML]="cardDetails?.cardPricingDetailText"
                                (click)="[scroll('#pricingDetailsSection'), anchorLink(cardDetails?.cardPricingDetailText)]" id="Pricing"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="extra">
            <div *ngFor="let item of cardDetails?.cardHighlights" [innerHTML]="item | safeHtml"></div>
            <div *ngIf="cardDetails?.cardFaqtext"><button role="link" cdsButton="inlineLink" [innerHTML]="cardDetails?.cardFaqtext"
                    (click)="[scroll('#faqSection'), anchorLink(cardDetails?.cardFaqtext)]" id="faq"></button></div>
        </div>
    </div>
    <ng-container *ngIf="headerContent?.enableBoxDesign">
        <app-header-section-box
            [cardDetails]="cardDetails"
            [reviewContent]="reviewContent"
            [headerContent]="headerContent"
            [hrefTarget]="hrefTarget"
            [prodName]="prodName"
            (anchorLinkClicked)="anchorLink($event)"
            (applyNowClicked)="applyNow($event)"
            (pricingInfoClicked)="pricingInfo($event)"
            (additionalInfoClicked)="additionalInfo($event)"
            (callToApplyClicked)="callToApplyModalOpen($event)"
            (taggingEmit)="taggingEmit.emit($event)"
        ></app-header-section-box>
    </ng-container>
    <app-sticky-header [headerContent]="headerContent" [cardDetails]="cardDetails" [rightAligned]="!!(headerContent?.enableBoxDesign)" [hrefTarget]="hrefTarget" [acqLink]="cardApplyNowBtnLink"
    [flowId]="flowId" (applyNowClicked)="applyNow($event)" (callToApplyClicked)="callToApplyModalOpen($event)">
    </app-sticky-header>
    <div class="spacer" role="presentation" aria-hidden="true"></div>
</section>
